import React, { Component } from "react";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
//components
import ReportsPage from "./Parts/ReportsPage";
import ReportsSideNav from "./Parts/ReportsSideNav";
import Loader from "../LoaderNew/Loader";
//funcs
import {
  getReport,
  generateReport,
  isExistReport,
} from "../../functions/api/orders";
import SideBar from "../SideBar/SideBar";
import * as actions from "../../actions/actions";
import { FULL_VIEW_ONLY, DEPARTMENT_ONLY, TASK_REMARK_ONLY, TASK_REMARK_QUANTITY_ONLY } from "../../tools/keys/variables";

class Reports extends Component {
  constructor() {
    super();
    this.state = {
      startingDate: moment().startOf("month"),
      endingDate: moment().endOf("month"),
      timestamp: {
        from: moment().startOf("month"),
        to: moment().endOf("month"),
      },
      dataArray: [],
      loader: false,
      isGenerated: false,
      csvData: [],
      changeToNewDates: true,
      total_actual: 0,
      total_planned: 0,
    };
  }

  async componentDidMount() {
    this.generateReport();
  }

  generateReport = async () => {
    let startingDate = moment(this.state.timestamp.from).format("DD/MM/YYYY");
    let endingDate = moment(this.state.timestamp.to).format("DD/MM/YYYY");
    this.setState({ isGenerated: false });
    let res = await generateReport(startingDate, endingDate, true);
    if (res.ok) {
      this.setState({
        startingDate,
        endingDate,
        changeToNewDates: true,
        isGenerated: true,
      });
      this.createDataForPage(res);
    }
  };

  createDataForPage = (data) => {
    // New API returns a flat array of { process, planned, actual }
    const rows = data.result && data.result.length ? data.result : [];
    const total_planned = rows.reduce((sum, item) => sum + (item.planned || 0), 0);
    const total_actual = rows.reduce(
      (sum, item) => sum + (parseFloat(item.billable) || 0),
      0
    );

    this.setState(
      {
        isGenerated: true,
        loader: false,
        dataArray: rows,
        total_planned,
        total_actual,
      },
      () => {
        this.initializedCsvData();
      }
    );
  };

  displayNewData = async () => {
    let startingDate = moment(this.state.timestamp.from).format("DD/MM/YYYY");
    let endingDate = moment(this.state.timestamp.to).format("DD/MM/YYYY");
    this.setState({ startingDate, endingDate }, async () => {
      this.setState({ loader: true });
      let res = await generateReport(startingDate, endingDate, true);
      if (res.ok && res.result.is_done) {
        this.createDataForPage(res.result.report);
      } else {
        this.setState({ loader: false });
      }
    });
    this.setState({ changeToNewDates: true });
  };

  checkExist = async () => {
    let res = await isExistReport();
    return res;
  };

  resetChangeToNewDates = () => {
    this.setState({ changeToNewDates: false });
  };

  setStartDate = (date) => {
    this.setState({ startingDate: moment(date) });
  };

  setEndDate = (date) => {
    this.setState({ endingDate: moment(date) });
  };

  setRange = (timestamp) => {
    this.setState({ timestamp });
  };

  updateDataArray = (new_data_array) => {
    const total_planned = new_data_array.reduce((sum, item) => sum + (item.planned || 0), 0);
    const total_actual = new_data_array.reduce((sum, item) => sum + (item.billable || 0), 0);
    this.setState(
      { dataArray: new_data_array, total_planned, total_actual },
      () => { this.initializedCsvData(); }
    );
  };

  // Kept for backwards compat but totals are now derived in updateDataArray/createDataForPage
  updateTotalActualValue = (value) => {
    this.setState({ total_actual: value }, () => this.initializedCsvData());
  };

  initializedCsvData = () => {
    const { startingDate, endingDate, reportsPageData } = this.props;
    const { dataArray } = this.state;

    const formatDate = (date) => {
      return typeof date === "string"
        ? date
        : moment(date).format("DD/MM/YYYY");
    };

    const csvData = [
      [
        'דו״ח פיננסי לחודש',
        `${formatDate(startingDate)} - ${formatDate(endingDate)}`
      ],
      [],
      ['סה״כ מתוכנן:', reportsPageData?.total_planned || 0],
      ['יצא:', reportsPageData?.total_actual || 0],
      [],
      ['שלב', 'כמות', 'מתוכנן', 'יצא'],
    ];

    (dataArray || []).forEach((item) => {
      csvData.push([
        item.process || '-',
        item.count || 0,
        item.planned || 0,
        item.billable || 0,
      ]);
    });

    this.setState({ csvData });
  };

  render() {
    const {
      startingDate,
      endingDate,
      loader,
      csvData,
      changeToNewDates,
      timestamp,
      isGenerated,
    } = this.state;

    const hasValidPrivilege = [FULL_VIEW_ONLY, DEPARTMENT_ONLY, TASK_REMARK_ONLY, TASK_REMARK_QUANTITY_ONLY].some(
      (priv) => this.props.login.user.privileges.includes(priv)
    );

    let reportsPageData = JSON.parse(JSON.stringify(this.state));

    return (
      <div className="reports__container">
        <SideBar />
        <div className="reports-page">
          {loader ? <Loader /> : null}
          <ReportsSideNav
            setStartDate={this.setStartDate}
            setEndDate={this.setEndDate}
            setRange={this.setRange}
            generateReport={this.generateReport}
            csvData={csvData}
            timestamp={timestamp}
            isGenerated={isGenerated}
          />
          <ReportsPage
            resetChangeToNewDates={this.resetChangeToNewDates}
            changeToNewDates={changeToNewDates}
            updateDataArray={this.updateDataArray}
            startingDate={startingDate}
            endingDate={endingDate}
            reportsPageData={reportsPageData}
            updateTotalActualValue={this.updateTotalActualValue}
            isGenerated={isGenerated}
            isViewOnlyAccess={hasValidPrivilege}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps({ login }) {
  return { login };
}

function mapDispatchToProps({ }) { }
export default withRouter(connect(mapStateToProps, actions)(Reports));